import React from 'react';
import {CollectionContext, ForEachModel} from '@morningtrain/react-resources';
import GroupOverview from 'app/components/widgets/order/GroupOverview';
import OrderOverview from 'app/components/widgets/order/OrderOverview';

export default class Overview extends React.Component {

    get group() {
        const {group_number, date, prices, customer} = this.props;

        return [{
            group_number: group_number,
            date:         date,
            prices:       prices,
            customer:     customer,
        }];
    }

    render() {
      const {orders} = this.props;

      return (
        <React.Fragment>
          <CollectionContext.Provider value={this.group}>
            <ForEachModel>
              <GroupOverview/>
            </ForEachModel>
          </CollectionContext.Provider>

          <CollectionContext.Provider value={orders}>
            <ForEachModel>
              <OrderOverview/>
                    </ForEachModel>
                </CollectionContext.Provider>
            </React.Fragment>
        );
    }
}
